import React from 'react';
import { Button } from 'antd';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import AddressRow from '../common/AddressRow/AddressRow';
import Measure from '../common/Measure';
import { houseInfoFieldsNames } from './constants/houseInfoFieldsNames';
import FieldsRow from '../../../common/formComponents/FieldsRow/FieldsRow';
import { getHouseInfoFieldsData } from './utils/getHouseInfoFieldsData';
import styles from './HouseInfoForm.module.scss';

const { totalArea } = houseInfoFieldsNames;

const HouseInfoForm = ({ form, initialValues, address }) => {
  const { setFieldsValue, getFieldValue, validateFields } =
    form;

  const totalAreaVal = getFieldValue(totalArea);

  const handleAddonAfterClick = (e) => {
    const name = e.target.dataset.fieldName;

    if (totalAreaVal) {
      setFieldsValue({ [name]: totalAreaVal });
      validateFields([totalArea], { force: true });
    }
  };

  const {
    firstRowFields,
    yearFields,
    numOfFields,
    numOfRoomsFields,
    areaFields,
    numOfElevatorsFields,
    // commentFields,
  } = getHouseInfoFieldsData({
    initialValues,
    form,
    areaInputProps: {
      suffix: <Measure str="м" index={2} />,
      addonAfter: (fieldName) => (
        <Button
          data-field-name={fieldName}
          type="link"
          onClick={handleAddonAfterClick}
          disabled={!totalAreaVal}
          className={styles.wholeFacilityBtn}
        >
          Весь объект
        </Button>
      ),
    },
  });

  return (
    <FormWrapper>
      <AddressRow address={address} />
      <FieldsRow gutter={10} fields={firstRowFields} form={form} />

      <FieldsRow gutter={10} fields={yearFields} form={form} />

      <FieldsRow gutter={10} fields={numOfFields} form={form} />

      <FieldsRow gutter={10} fields={numOfRoomsFields} form={form} />

      <FieldsRow gutter={10} fields={areaFields} form={form} />
      <FieldsRow gutter={10} fields={numOfElevatorsFields} form={form} />
      {/* <FieldsRow gutter={10} fields={commentFields} form={form} /> */}
    </FormWrapper>
  );
};

export default HouseInfoForm;
